import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-poi_clean",
  "use": "icon-poi_clean-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-poi_clean\"><g stroke=\"#595959\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.4\" clip-path=\"url(#icon-poi_clean_a)\"><path d=\"M3.992 4.925 10.134 3l6.142 1.925C17.466 10.5 15.131 16 10.135 17c-5.003-1.167-7.836-6.5-6.142-12.075\" /><path d=\"m7 9.65 2.121 2.121L12.893 8\" /></g><defs><clipPath id=\"icon-poi_clean_a\"><path fill=\"#fff\" d=\"M2 2h16v16H2z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol